"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sizes = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.array.iterator");
require("core-js/modules/es6.object.to-string");
require("core-js/modules/es6.object.keys");
require("core-js/modules/es6.object.assign");
require("core-js/modules/es6.regexp.match");
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null)
    return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
        continue;
    target[key] = source[key];
} return target; }
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const _utils_1 = require("@utils");
var Image = function Image(_ref) {
    var _ref$objectFit = _ref.objectFit, objectFit = _ref$objectFit === void 0 ? 'contain' : _ref$objectFit, className = _ref.className, src = _ref.src, mobileSrc = _ref.mobileSrc, _ref$widthClass = _ref.widthClass, widthClass = _ref$widthClass === void 0 ? 'bodyMargin' : _ref$widthClass, children = _ref.children, props = _objectWithoutPropertiesLoose(_ref, ["objectFit", "className", "src", "mobileSrc", "widthClass", "children"]);
    /* We don't want to return SVGs as <Picture> tags with webp and png.
     *
     * Note: If <picture> does become desirable for some reason, we can return…
     *   <picture><img src="file.svg" /></picture>
     * … without the <source /> tags.
     *
     * Note: SVG is not returned with fade-in effect.
     *
     * Note: this is unstyled.
     *  We may want to return some kind of <StyledImgForSvg /> tag down the road,
     *  with styling that is identical to or similar to <StyledImg />.
     */
    if (src.match(/\.svg/)) {
        return /*#__PURE__*/ react_1.default.createElement("img", Object.assign({
            src: src,
            className: className
        }, props));
    }
    /* # Loaded state
     *
     * The loaded state enables our "fade in" effect.
     *
     * It is _very important_ that onLoad is listed before SRC in the <img /> tag.
     * Otherwise, cached images will load before an event handler is set up to change the opacity.
     *
     * We are also using a small timeout to set the "loaded" state.
     * Without that timeout, a cached image will set opacity immediately and there will be no transition.
     */
    var _React$useState = react_1.default.useState(false), loaded = _React$useState[0], setLoaded = _React$useState[1];
    var timer;
    var initiate = function initiate() {
        timer = setTimeout(function () {
            return setLoaded(true);
        }, 5);
    };
    /* If the image is cached, we need use React.useEffect() to detect completion state. */
    var theRef = react_1.default.useRef(null);
    react_1.default.useEffect(function () {
        var _theRef$current;
        if (theRef === null || theRef === void 0 ? void 0 : (_theRef$current = theRef.current) === null || _theRef$current === void 0 ? void 0 : _theRef$current.complete) {
            setLoaded(true);
        }
        return function () {
            return clearTimeout(timer);
        }; // ^ Clear that timer so, in event of an early component dismount, we don't wind up with a memory leak error.
    }, []); // Set CDN src. 
    var cdnSrc = _utils_1.imgixPath(src);
    var mobileCdnSrc = mobileSrc ? _utils_1.imgixPath(mobileSrc) : cdnSrc;
    return /*#__PURE__*/ react_1.default.createElement("picture", null, !!children && children, !children && /*#__PURE__*/ react_1.default.createElement(react_1.default.Fragment, null, /*#__PURE__*/ react_1.default.createElement("source", {
        type: "image/webp",
        media: "(max-width: 767px)",
        srcSet: mobileCdnSrc + "?fm=webp&w=" + exports.sizes[widthClass]['mobile']
    }), /*#__PURE__*/ react_1.default.createElement("source", {
        type: "image/webp",
        media: "(min-width: 1280px)",
        srcSet: cdnSrc + "?fm=webp&w=" + exports.sizes[widthClass]['desktop'] + ", " + cdnSrc + "?fm=webp&w=" + exports.sizes[widthClass]['desktop'] * 2 + " 2x"
    }), /*#__PURE__*/ react_1.default.createElement("source", {
        type: "image/webp",
        media: "(min-width: 1024px)",
        srcSet: cdnSrc + "?fm=webp&w=" + exports.sizes[widthClass]['laptop'] + ", " + cdnSrc + "?fm=webp&w=" + exports.sizes[widthClass]['laptop'] * 2 + " 2x"
    }), /*#__PURE__*/ react_1.default.createElement("source", {
        type: "image/webp",
        media: "(min-width: 768px)",
        srcSet: cdnSrc + "?fm=webp&w=" + exports.sizes[widthClass]['tablet'] + ", " + cdnSrc + "?fm=webp&w=" + exports.sizes[widthClass]['tablet'] * 2 + " 2x"
    }), /*#__PURE__*/ react_1.default.createElement("source", {
        type: "image/jp2",
        media: "(max-width: 767px)",
        srcSet: mobileCdnSrc + "?fm=jp2&w=" + exports.sizes[widthClass]['mobile']
    }), /*#__PURE__*/ react_1.default.createElement("source", {
        type: "image/jp2",
        media: "(min-width: 1280px)",
        srcSet: cdnSrc + "?fm=jp2&w=" + exports.sizes[widthClass]['desktop'] + ", " + cdnSrc + "?fm=jp2&w=" + exports.sizes[widthClass]['desktop'] * 2 + " 2x"
    }), /*#__PURE__*/ react_1.default.createElement("source", {
        type: "image/jp2",
        media: "(min-width: 1024px)",
        srcSet: cdnSrc + "?fm=jp2&w=" + exports.sizes[widthClass]['laptop'] + ", " + cdnSrc + "?fm=jp2&w=" + exports.sizes[widthClass]['laptop'] * 2 + " 2x"
    }), /*#__PURE__*/ react_1.default.createElement("source", {
        type: "image/jp2",
        media: "(min-width: 768px)",
        srcSet: cdnSrc + "?fm=jp2&w=" + exports.sizes[widthClass]['tablet'] + ", " + cdnSrc + "?fm=jp2&w=" + exports.sizes[widthClass]['tablet'] * 2 + " 2x"
    })), /*#__PURE__*/ react_1.default.createElement(StyledImage, Object.assign({
        ref: theRef,
        loading: "lazy"
    }, {
        loaded: loaded,
        objectFit: objectFit
    }, {
        onLoad: initiate,
        className: "loadable " + className
    }, props)));
}; // Styling
var StyledImage = styled_components_1.default.img.withConfig({
    displayName: "Image__StyledImage",
    componentId: "nr2smn-0"
})(["display:block;width:100%;height:100%;margin:0;padding:0;border:0;object-fit:", ";transition:opacity 0.5s ease-in-out;opacity:", ";"], function (props) {
    return props.objectFit;
}, function (props) {
    return !props.loaded ? 0 : 1;
}); // Typing
// Helpers
/* # Responsive image media queries
*
* We start out with a retina grade image for mobile, as effectively all mobile devices are retina.
* The current “big screen” is iPhone 12 at 540 "screen units" wide, or 1080 real pixels.
* This scales down to smaller phones just fine, and 3x OLED screens don’t benefit from 1:1 images much.
*
* Then we have regular and retina sized images for each of responsive breakpoints.
*
* All sizes are listed in both jp2 (Safari) and webp (Chrome/Firefox).
*/
exports.sizes = {
    'float': {
        'mobile': 828,
        'tablet': 314,
        'laptop': 429,
        'desktop': 544
    },
    'overlap': {
        'mobile': 828,
        'tablet': 582,
        'laptop': 724,
        'desktop': 880
    },
    'tricolumn': {
        'mobile': 828,
        'tablet': 332,
        'laptop': 293,
        'desktop': 373
    },
    'bodyMargin': {
        'mobile': 828,
        'tablet': 768,
        'laptop': 1024,
        'desktop': 1280
    }
};
exports.default = Image;
